import { css } from "@emotion/react";

export const container = css`
  width: 100%;
  text-align: center;
  padding: 1rem;
`;
